import moment from "moment";
import React from "react";

import { ScheduledJob } from "../../../../dtos/scheduledJob";
import { SCHEDULED_JOB_TYPE_LABELS, ScheduledJobType } from "../../../../enums/ScheduledJobType";
import { ResponsiveDataView, Column } from "../../../shared/ResponsiveDataView";
import { EditScheduledJobButton } from "../EditScheduledJobButton";
import { DeleteScheduledJobButton } from "../DeleteScheduledJobButton";

interface Props {
    jobs: ScheduledJob[];
    setJobs: (jobs: ScheduledJob[]) => void;
    loadJobs: () => void;
    availableJobTypes: ScheduledJobType[];
    isLoading?: boolean;
}

export function ScheduledJobsTable({ jobs, setJobs, loadJobs, availableJobTypes, isLoading }: Props) {
    const handleJobDeleted = (id: number) => {
        setJobs(jobs.filter(it => it.id !== id));
    }

    const handleJobSaved = (job: ScheduledJob) => {
        setJobs(jobs.map((prev) => (prev.id === job.id ? { ...prev, ...job } : prev)));
        loadJobs();
    }

    const columns: Column<ScheduledJob>[] = [
        {
            key: 'type',
            label: 'Type',
            render: (it) => SCHEDULED_JOB_TYPE_LABELS[it.type],
        },
        { key: 'name', label: 'Name', primary: true },
        {
            key: 'addedOn',
            label: 'Added',
            render: (it) => `${moment.utc(it.addedOn).format("M/DD/YYYY h:mm:ss A Z z")} by ${it.addedByName}`,
        },
        {
            key: 'modifiedOn',
            label: 'Modified',
            hideWhenEmpty: true,
            render: (it) => it.modifiedOn
                ? `${moment.utc(it.modifiedOn).format("M/DD/YYYY h:mm:ss A Z z")}${it.modifiedByName ? ` by ${it.modifiedByName}` : ""}`
                : "",
        },
    ];

    const rowActions = (it: ScheduledJob) => (
        <>
            <EditScheduledJobButton
                job={it}
                onJobSaved={handleJobSaved}
                availableJobTypes={availableJobTypes.includes(it.type)
                    ? availableJobTypes
                    : [...availableJobTypes, it.type]
                }
            />
            <DeleteScheduledJobButton job={it} onJobDeleted={handleJobDeleted} />
        </>
    );

    return (
        <ResponsiveDataView
            rows={jobs}
            columns={columns}
            rowKey={(it) => it.id}
            actions={rowActions}
            loading={isLoading}
        />
    );
}
